import { LegalPage } from '@/components/legal/LegalPage'
import { termsConditions } from '@/content/legal'

export function Terms() {
  return <LegalPage doc={termsConditions} path="/terms" />
}
